"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _PlusCircleIcon = _interopRequireDefault(require("../../../../icons/standard-icons/PlusCircleIcon"));

var _MinusCircleIcon = _interopRequireDefault(require("../../../../icons/standard-icons/MinusCircleIcon"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const ToolbarZoomNav = ({
  zoom,
  minZoom,
  maxZoom,
  zoomIncrement,
  onZoomChange,
  ...otherProps
}) => {
  const zoomIn = () => {
    onZoomChange(zoom + zoomIncrement);
  };

  const zoomOut = () => {
    onZoomChange(zoom - zoomIncrement);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.StyledToolbarZoomNav, { ...otherProps,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ZoomOutButton, {
      tooltip: "Zoom out",
      onClick: zoomOut,
      disabled: zoom < minZoom + zoomIncrement,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_MinusCircleIcon.default, {})
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ZoomLabel, {
      children: `${zoom}%`
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ZoomInButton, {
      tooltip: "Zoom in",
      onClick: zoomIn,
      disabled: zoom > maxZoom - zoomIncrement,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_PlusCircleIcon.default, {})
    })]
  });
};

ToolbarZoomNav.defaultProps = {
  minZoom: 25,
  maxZoom: 400,
  zoomIncrement: 25
};
ToolbarZoomNav.propTypes = {
  zoom: _propTypes.default.number.isRequired,
  minZoom: _propTypes.default.number,
  maxZoom: _propTypes.default.number,
  zoomIncrement: _propTypes.default.number,
  onZoomChange: _propTypes.default.func.isRequired
};
var _default = ToolbarZoomNav;
exports.default = _default;